import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'

/** Procesos auditados (coinciden con los del backend). */
export type ProcesoEjecucion =
  | 'consulta_lunes'
  | 'recordatorio_miercoles'
  | 'corte_viernes'
  | 'recalculo'
  | 'aviso'

export type EstadoEjecucion = 'ok' | 'error' | 'abortado' | 'simulado'

export interface Ejecucion {
  id: string
  proceso: ProcesoEjecucion
  estado: EstadoEjecucion
  resumen: string
  detalle: Record<string, unknown> | null
  simulado: boolean
  iniciadaEn: string
  terminadaEn: string | null
}

interface RespuestaAuditoria {
  items: Ejecucion[]
  total: number
}

/**
 * Últimas ejecuciones de los procesos del ciclo (panel de Auditoría).
 * Opcionalmente filtra por un proceso concreto.
 */
export function useAuditoria(proceso?: ProcesoEjecucion) {
  const api = useApi()
  return useQuery<RespuestaAuditoria, ErrorApi>({
    queryKey: ['auditoria', proceso ?? 'todos'],
    queryFn: ({ signal }) =>
      api.pedir<RespuestaAuditoria>('/api/auditoria', {
        senal: signal,
        parametros: proceso ? { proceso } : undefined,
      }),
  })
}
